import React from 'react';
import { array, bool, number, string } from 'prop-types';

import { connect } from 'react-redux';

import AgentStep from './AgentStep';
import ProfileStep from './ProfileStep';
import EquipmentStep from './EquipmentStep';

import CreateEquipmentTable from './CreateEquipmentTable';
import CreateSensorTable from './CreateSensorTable';
import ProfileTable from './ProfileTable';
import ProfileObjectTable from './ProfileObjectTable';
import MapObjectToSensorTable from './MapObjectToSensorTable';
import SillyTable from './SillyTable';

import * as WizardActions from '../../../actions/wizardActions';

import classes from './WizardStep.module.css';

const WizardStep = ({
    activeStep,
    form,
    selectedSite,
    ...props
}) => {
    const setWizardClass = () => {
        if (form) {
            return classes.WizardStepWithForm;
        }

        return classes.WizardStep;
    };

    const renderForm = () => {
        switch (activeStep) {
            case 0:
                return (
                    <AgentStep selectedSite={selectedSite} />
                );
            case 1:
                return (
                    <ProfileStep />
                );
            case 2:
                return (
                    <EquipmentStep />
                );
            default:
                break;
        }
    };

    const renderTable = () => {
        switch (activeStep) {
            case 0:
                return (
                    <div className={classes.wizardTable}>
                        <ProfileTable />
                    </div>
                );
            case 1:
                return (
                    <div className={classes.wizardTable}>
                        <ProfileObjectTable />
                    </div>
                );
            case 2:
                return (
                    <div className={classes.wizardTable}>
                        <SillyTable />
                    </div>
                );
            case 3:
                return (
                    <div className={classes.wizardTable}>
                        <CreateEquipmentTable />
                    </div>
                );
            case 4:
                return (
                    <div className={classes.wizardTable}>
                        <MapObjectToSensorTable />
                    </div>
                );
            case 5:
                return (
                    <div className={classes.wizardTable}>
                        <CreateSensorTable />
                    </div>
                );
            default:
                break;
        }
    };

    return (
        <div className={setWizardClass()}>
            {form ? renderForm() : null}
            {renderTable()}
        </div>
    );
};

WizardStep.defaultProps = {
    activeStep: 0,
    form:       true,
    steps:      [],
    title:      ''
};

WizardStep.propTypes = {
    activeStep: number,
    form:       bool,
    steps:      array,
    title:      string
};

const mapStateToProps = state => {
    return {
        activeStep: state.wizard.activeStep,
        steps:      state.wizard.steps
    };
};

const mapDispatchToProps = {
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardStep);
